module.exports = __webpack_public_path__ + "img/banner_bg_obligatory.d93badb2.jpg";